import React from "react";
import closeV2 from "../../../static/image/v2/popup/closeV2.png";
import {closePopup} from "../../../static/js/Common2";

export default function OrderPopupV2() {
  return (
    <div id="orderPopup" className="popupV2 hide">
      <div className="popupContainer width578">
        <div className='popupTitle'>
          <h2>주문 상세</h2>
          <button className='closeBtn stopCloseBtn' onClick={() => closePopup("orderPopup")}>
            <img src={ closeV2 } alt='취소' />
          </button>
        </div>
        <div className='popupContent'>
          <div className='popupFlexBox popupFlexBox1'>
            <div className='flexTitle'>주문번호</div>
            <div className='flexContent'>
              <input id='orderId' type='text' readOnly />
            </div>
          </div>
          <div className='popupFlexBox popupFlexBox1'>
            <div className='flexTitle'>배달주소</div>
            <div className='flexContent'>
              <input id='address' type='text' readOnly />
            </div>
          </div>
          <div className='popupFlexBox popupFlexBox1'>
            <div className='flexTitle'>연락처</div>
            <div className='flexContent'>
              <input id='tel' type='text' readOnly />
            </div>
          </div>
          <div className='popupFlexBox popupFlexBox1'>
            <div className='flexTitle'>매장 요청사항</div>
            <div className='flexContent'>
              <input id='shopMemo' type='text' readOnly />
            </div>
          </div>
          <div className='popupFlexBox popupFlexBox1'>
            <div className='flexTitle'>기사 요청사항</div>
            <div className='flexContent'>
              <input id='riderMemo' type='text' readOnly />
            </div>
          </div>
          <div id="cancelTypeBox" className='popupFlexBox popupFlexBox1 hide'>
            <div className='flexTitle'>취소 사유</div>
            <div className='flexContent'>
              <input id='cancelType' type='text' readOnly />
            </div>
          </div>
          <div className='popupFlexBox popupFlexBox1'>
            <div className='flexTitle'>주문내역</div>
          </div>
          <table>
            <thead>
            <tr>
              <th>메뉴(상품)명</th>
              <th>금액</th>
              <th>수량</th>
              <th>총금액</th>
            </tr>
            </thead>
            <tbody id="orderTbody">

            </tbody>
          </table>
        </div>
      </div>

    </div>
  )
}